module.exports = __webpack_public_path__ + "img/bookShelf.ea4d537a.svg";